import loadable from '@loadable/component';

export const CmsImageGalleryBlockLoadable = loadable(
  () => import('./CmsImageGalleryBlock'),
  { resolveComponent: (module) => module.CmsImageGalleryBlock },
);
